module.exports = __webpack_public_path__ + "media/images/seller-guide-carmen-thumb-8c643206b5e70bb0eaf82f457b2b67c0.jpg";